import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

const api = axios.create({
  baseURL: 'https://analisador-api-service-861393614978.southamerica-east1.run.app/api/v1',
});

const handleExpiredSession = () => {
  localStorage.removeItem('authToken');
  if (typeof window !== 'undefined') {
    window.location.href = '/';
  }
};

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('authToken');

    const isAbsoluteUrl = /^https?:\/\//i.test(config.url || '');

    if (token && !isAbsoluteUrl) {
      try {
        const decodedToken = jwtDecode(token);
        const tokenExpiration = decodedToken?.exp ? decodedToken.exp * 1000 : null;

        if (!tokenExpiration || tokenExpiration <= Date.now()) {
          handleExpiredSession();
          return Promise.reject(new Error('Sessão expirada.'));
        }
        
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        handleExpiredSession();
        return Promise.reject(new Error('Token inválido.'));
      }
    }

    return config;
  },
  error => Promise.reject(error)
);

export default api;